const depoimentos = [
  {
    frase: '"O fechamento de sacada da Thelux transformou completamente a qualidade de vida no meu apartamento. Silêncio, proteção e uma estética impecável que valorizou muito o meu imóvel."',
    nome: 'Rodrigo Almeida',
    cargo: 'Proprietário — Moema, São Paulo',
    estrelas: 5,
  },
  {
    frase: '"O envidraçamento de sacada foi o melhor investimento que fiz no meu imóvel. A equipe da Thelux foi extremamente profissional, do projeto à instalação. Recomendo sem hesitar."',
    nome: 'Fernanda Costa',
    cargo: 'Arquiteta e Proprietária — Itaim Bibi, São Paulo',
    estrelas: 5,
  },
  {
    frase: '"Com o fechamento de sacada articulado sem roldana, ganhei conforto, silêncio e sofisticação. Minha varanda virou o ambiente favorito da casa. A Thelux entrega o que promete."',
    nome: 'Marcelo Souza',
    cargo: 'Empresário — Jardins, São Paulo',
    estrelas: 5,
  },
];

export default function FrasesMotivadoras() {
  return (
    <section className="py-16 md:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-bold tracking-widest text-amber-600 uppercase mb-3">
            DEPOIMENTOS
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 leading-tight">
            Quem Escolheu a Thelux, Não Arrependeu
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {depoimentos.map((d) => (
            <div key={d.nome} className="bg-white rounded-2xl p-7 flex flex-col">
              <div className="flex gap-1 mb-4">
                {Array.from({ length: d.estrelas }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-sm"></i>
                  </div>
                ))}
              </div>
              <p className="text-stone-600 text-sm leading-relaxed flex-1 italic mb-5">{d.frase}</p>
              <div className="flex items-center gap-3 pt-4 border-t border-stone-100">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-stone-200 text-stone-500 shrink-0">
                  <i className="ri-user-line text-base"></i>
                </div>
                <div>
                  <p className="font-semibold text-stone-800 text-sm">{d.nome}</p>
                  <p className="text-stone-400 text-sm">{d.cargo}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
